export interface ProductLineGroup {
    productLineGroupId: number;
    productLineGroupName?: string | null;
}

// biome-ignore lint/suspicious/noExplicitAny: we need to use any
export function hasProductLineGroupId(obj: any): obj is { productLineGroupId: number } {
    return obj && typeof obj.productLineGroupId === 'number';
}

// biome-ignore lint/suspicious/noExplicitAny: we need to use any
export function isProductLineGroup(obj: any): obj is ProductLineGroup {
    return typeof obj?.productLineGroupId === 'number' && typeof obj?.productLineGroupName === 'string';
}
